const theme = {}
export default { baseUrl: 'https://scanx.live/api/v1', theme }
// export default { baseUrl: 'http://127.0.0.1:8000/api/v1', theme }
// export default { baseUrl: 'https://gdmlaravel.herokuapp.com/api/v1', theme }
